import { render, staticRenderFns } from "./t-dialog.vue?vue&type=template&id=be9cd43e&lang=pug"
import script from "./t-dialog.vue?vue&type=script&lang=js"
export * from "./t-dialog.vue?vue&type=script&lang=js"
import style0 from "./t-dialog.vue?vue&type=style&index=0&id=be9cd43e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports